import { createAsyncAction } from 'redux-promise-middleware-actions';
import api from '../Api/apiIS';
import { getActionTypesResult } from '../utils';

export const licenseSettingsConstants = {
    LICENSE_SETTINGS_PLANNED_PAYMENTS_LOADED: 'LICENSE_SETTINGS_PLANNED_PAYMENTS_LOADED',
    LICENSE_SETTINGS_PLANNED_PAYMENTS_CREATED: 'LICENSE_SETTINGS_PLANNED_PAYMENTS_CREATED',
    LICENSE_SETTINGS_ACTUAL_PAYMENTS_LOADED: 'LICENSE_SETTINGS_ACTUAL_PAYMENTS_LOADED',
    LICENSE_SETTINGS_ACTUAL_PAYMENTS_CREATED: 'LICENSE_SETTINGS_ACTUAL_PAYMENTS_CREATED',

};

export const licenseSettingsFulfilledConstants = getActionTypesResult(licenseSettingsConstants, '_FULFILLED');
export const licenseSettingsPendingConstants = getActionTypesResult(licenseSettingsConstants, '_PENDING');
export const licenseSettingsRejectedConstants = getActionTypesResult(licenseSettingsConstants, '_REJECTED');

export const fetchPlannedPayment =
createAsyncAction(licenseSettingsConstants.LICENSE_SETTINGS_PLANNED_PAYMENTS_LOADED, () =>
    api.get('settings/license/schedule/planned/payments/review/get').then(res => res.data)
);

export const savePlannedPayment =
    createAsyncAction(
        licenseSettingsConstants.LICENSE_SETTINGS_PLANNED_PAYMENTS_CREATED,
        data => api.post('settings/license/schedule/planned/payments/review/set', data).then(res => res.data)
    );

export const fetchActualPayment =
createAsyncAction(licenseSettingsConstants.LICENSE_SETTINGS_ACTUAL_PAYMENTS_LOADED, () =>
    api.get('settings/license/schedule/actual/payments/review/get').then(res => res.data)
);

export const saveActualPayment =
    createAsyncAction(
        licenseSettingsConstants.LICENSE_SETTINGS_ACTUAL_PAYMENTS_CREATED,
        data => api.post('settings/license/schedule/actual/payments/review/set', data).then(res => res.data)
    );
